module.exports = __webpack_public_path__ + "static/media/KYC.29ad7bcc.png";